export const JOBS_RESET_STATE = 'JOBS_RESET_STATE';
export const JOBS_CURRENT_ITEM = 'JOBS_CURRENT_ITEM';

export const JOBS_REQUEST_LOADING = 'JOBS_REQUEST_LOADING';
export const JOBS_REQUEST_SUCCESS = 'JOBS_REQUEST_SUCCESS';
export const JOBS_REQUEST_FAILED = 'JOBS_REQUEST_FAILED';

export const JOBS_CURRENT_ACTION = 'JOBS_CURRENT_ACTION';
export const JOBS_RESET_ACTION = 'JOBS_RESET_ACTION';